import { Flex, Grid } from '@chakra-ui/react';
import React, { useLayoutEffect } from 'react';
import { useParams } from 'react-router-dom';
import { SimpleCarousel, useAppDispath, RichText } from 'shared';
import { Helmet } from 'react-helmet-async';
// eslint-disable-next-line no-restricted-imports
import { richTextToString } from 'shared/lib/richtext-to-string';
import { CateringEventPageMainHeader } from './CateringEventPageMainHeader';
import { CateringEventPageActions, useCateringEventPageState } from '../../store';

export const CateringEventPageMain = () => {
    const { slug } = useParams();
    const dispatch = useAppDispath();
    const { cateringEvent } = useCateringEventPageState();

    useLayoutEffect(() => {
        if (slug) dispatch(CateringEventPageActions.getCateringEventBySlug({ slug }));
    }, [slug]);

    return (
        <Flex
            gap="2rem"
            padding="2rem"
            flexDirection="column"
            maxWidth={{
                base: '425px',
                lg: '1280px',
            }}
            background="white"
            width="100%"
            margin="0 auto"
        >
            <Helmet>
                <title>{cateringEvent?.name}</title>
                <meta name="description" content={richTextToString(cateringEvent?.description)} />
                <meta property="og:title" content={cateringEvent?.name} />
            </Helmet>
            <CateringEventPageMainHeader
                name={cateringEvent?.name || ''}
            />
            <Grid
                templateColumns={{
                    base: '1fr',
                    lg: '2fr 3fr',
                }}
                gap="2rem"
            >
                <RichText
                    flex="1 0 40%"
                    content={cateringEvent?.description || []}
                />
                <SimpleCarousel
                    flex="1 0 50%"
                    aspectRatio="1 / 1"
                    images={cateringEvent?.images?.map(({ url }) => url) || []}
                />
            </Grid>
        </Flex>
    );
};
